<template>
  <div v-if="instance">
    <div class="row" v-if="instance.project">
      <div class="col-12 col-md-8">
        <div class="card card-custom gutter-b">
          <div class="card-body">
            <div class="row align-items-center justify-content-between">
              <div class="col-6 pb-0">
                <div class="text">
                  <div>
                    <h3 class="font-weight-bolder mb-6">
                      {{ instance.project.title }}
                    </h3>
                    <div v-for="i in usuari.instances" :key="i._id">
                      <div
                        v-if="
                          i.dateFinished &&
                            i._id === instance._id &&
                            i.project.sections.length === 0
                        "
                        class="row"
                      >
                        <div class="col-md-6">
                          <span class="d-block font-weight-bold mb-4"
                            >Stars</span
                          >
                          <div class="row ml-0 my-1">
                            <div>
                              <i v-if="i.stars >= 1" class="fas fa-star"></i>
                              <i v-else class="far fa-star"></i>
                            </div>
                            <div>
                              <i v-if="i.stars >= 2" class="fas fa-star"></i>
                              <i v-else class="far fa-star"></i>
                            </div>
                            <div>
                              <i v-if="i.stars >= 3" class="fas fa-star"></i>
                              <i v-else class="far fa-star"></i>
                            </div>
                            <div>
                              <i v-if="i.stars >= 4" class="fas fa-star"></i>
                              <i v-else class="far fa-star"></i>
                            </div>
                            <div>
                              <i v-if="i.stars >= 5" class="fas fa-star"></i>
                              <i v-else class="far fa-star"></i>
                            </div>
                          </div>
                        </div>
                        <div
                          class="col-6 col-md-6"
                          v-for="po in i.project.points"
                          :key="po._id"
                        >
                          <div>
                            <!-- v-if="s.dateFinished" -->
                            <span class="d-block font-weight-bold mb-4"
                              >Points achieved</span
                            >
                            <div class="row ml-0 my-1">
                              <div>
                                <span
                                  v-if="i.stars == 1"
                                  class="btn btn-light-danger btn-sm font-weight-bold btn-upper btn-text"
                                  >{{ po.points * 0.1 }} points</span
                                >
                                <span
                                  v-else-if="i.stars == 2"
                                  class="btn btn-light-warning btn-sm font-weight-bold btn-upper btn-text"
                                  >{{ po.points * 0.3 }} points</span
                                >
                                <span
                                  v-else-if="i.stars == 3"
                                  class="btn btn-light-warning btn-sm font-weight-bold btn-upper btn-text"
                                  >{{ po.points * 0.5 }} points</span
                                >
                                <span
                                  v-else-if="i.stars == 4"
                                  class="btn btn-light-success btn-sm font-weight-bold btn-upper btn-text"
                                  >{{ po.points * 0.7 }} points</span
                                >
                                <span
                                  v-else-if="i.stars == 5"
                                  class="btn btn-light-success btn-sm font-weight-bold btn-upper btn-text"
                                  >{{ po.points }} points</span
                                >
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="d-flex flex-wrap mt-14">
                    <div
                      class="mr-12 d-flex flex-column mb-2"
                      v-if="instance.project.startDate"
                    >
                      <span class="d-block font-weight-bold mb-4"
                        >Start Date</span
                      >
                      <span
                        class="btn btn-light-primary btn-sm font-weight-bold btn-upper btn-text"
                        >{{
                          instance.project.startDate | moment("D MMM  YYYY")
                        }}</span
                      >
                    </div>
                    <div
                      class="mr-12 d-flex flex-column mb-2"
                      v-if="instance.project.endDate"
                    >
                      <span class="d-block font-weight-bold mb-4"
                        >Due Date</span
                      >
                      <span
                        class="btn btn-light-danger btn-sm font-weight-bold btn-upper btn-text"
                        >{{
                          instance.project.endDate | moment("D MMM  YYYY")
                        }}</span
                      >
                    </div>
                  </div>
                </div>
              </div>
              <div class="col-6 text-right">
                <span class="btn btn-success" v-if="instance.dateFinished"
                  >Finished</span
                >
                <span
                  class="btn btn-warning"
                  v-if="
                    !instance.dateFinished &&
                      !instance.cancelled &&
                      instance.verification.length < 1
                  "
                  >Live</span
                >
                <span class="btn btn-danger" v-if="instance.cancelled"
                  >Cancelled</span
                >
                <span
                  class="btn btn-danger"
                  v-if="instance.verification.length > 0"
                  >Verificated</span
                >
                <div class="row justify-content-end mt-5">
                  <v-col :cols="2" v-for="t in project.tags" :key="t._id">
                    <div
                      class="d-flex justify-content-center align-items-center info-singel-project tag-dev mb-2 text-center"
                      v-b-tooltip.hover
                      :title="t.description"
                    >
                      <span class="text-dark-75 font-weight-bolder mr-2">{{
                        t.name
                      }}</span>
                    </div>
                  </v-col>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="criteria" v-if="instance.project.description">
          <div class="card card-custom gutter-b">
            <div class="card-body">
              <h4 class="text-dark mb-5">Description</h4>
              <p v-html="instance.project.description"></p>
            </div>
          </div>
        </div>
        <div class="descripcio" v-if="instance.project.criteria">
          <div class="card card-custom gutter-b">
            <div class="card-body">
              <h4 class="text-dark mb-5">Criteria</h4>
              <p v-html="instance.project.criteria"></p>
            </div>
          </div>
        </div>
        <div v-for="(s, index) in instance.project.sections" :key="s._id">
          <!-- <div v-for="(u,index) in instance.users" :key="index">
            <div class="btn btn-block btn-primary font-weight-bolder py-4 mb-5" v-if="u==currentUser.user.userId" v-on:click="createInstance(project._id,s._id,currentUser.user.userId)">Start project</div>
          </div> -->
          <div class="card card-custom gutter-b example example-compact">
            <div class="card-header">
              <div class="card-title">
                <h3 class="card-label font-weight-boldest">
                  <i class="flaticon2-layers mr-8"></i> {{ s.title }}
                </h3>
              </div>
              <div
                class="col-6 col-md-6 pt-0"
                v-for="po in s.points"
                :key="po._id"
              >
                <!-- !i.project.hasParent -->
                <div v-for="i in usuari.instances" :key="i._id">
                  <div
                    v-if="i.dateFinished && i.project._id == s._id"
                    class="row align-items-center justify-content-end"
                  >
                    <div class="col-7 text-right">
                      <div class="row ml-0 my-1 justify-content-end">
                        <div>
                          <i v-if="i.stars >= 1" class="fas fa-star"></i>
                          <i v-else class="far fa-star"></i>
                        </div>
                        <div>
                          <i v-if="i.stars >= 2" class="fas fa-star"></i>
                          <i v-else class="far fa-star"></i>
                        </div>
                        <div>
                          <i v-if="i.stars >= 3" class="fas fa-star"></i>
                          <i v-else class="far fa-star"></i>
                        </div>
                        <div>
                          <i v-if="i.stars >= 4" class="fas fa-star"></i>
                          <i v-else class="far fa-star"></i>
                        </div>
                        <div>
                          <i v-if="i.stars >= 5" class="fas fa-star"></i>
                          <i v-else class="far fa-star"></i>
                        </div>
                      </div>
                    </div>
                    <div
                      class="col-5 text-right"
                      v-for="po in s.points"
                      :key="po._id"
                    >
                      <div>
                        <div>
                          <span
                            v-if="i.stars == 1"
                            class="btn btn-light-danger btn-sm font-weight-bold btn-upper btn-text"
                            >{{ po.points * 0.1 }} points</span
                          >
                          <span
                            v-else-if="i.stars == 2"
                            class="btn btn-light-warning btn-sm font-weight-bold btn-upper btn-text"
                            >{{ po.points * 0.3 }} points</span
                          >
                          <span
                            v-else-if="i.stars == 3"
                            class="btn btn-light-warning btn-sm font-weight-bold btn-upper btn-text"
                            >{{ po.points * 0.5 }} points</span
                          >
                          <span
                            v-else-if="i.stars == 4"
                            class="btn btn-light-success btn-sm font-weight-bold btn-upper btn-text"
                            >{{ po.points * 0.7 }} points</span
                          >
                          <span
                            v-else-if="i.stars == 5"
                            class="btn btn-light-success btn-sm font-weight-bold btn-upper btn-text"
                            >{{ po.points }} points</span
                          >
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="card-toolbar">
                <div class="example-tools justify-content-center">
                  <div
                    class="btn btn-primary font-weight-bolder px-7 mr-5"
                    v-if="index == numSeccionsAmbInstancia && ultimaAcabada"
                    v-on:click="
                      createInstance(
                        s._id,
                        s.numberOfUsers,
                        s._id,
                        currentUser.user
                      )
                    "
                  >
                    Start project
                  </div>
                  <b-button v-b-toggle="'collapse-' + index"
                    ><i class="fas fa-angle-down"></i
                  ></b-button>
                </div>
              </div>
            </div>
            <b-collapse
              :visible="index == count"
              v-bind:id="'collapse-' + index"
              class="mt-2"
            >
              <div v-for="i in usuari.instances" :key="i._id">
                <div v-if="i.project._id == s._id">
                  <div class="card-body">
                    <h3 class="font-weight-bolder" v-if="s.description">
                      Description
                    </h3>
                    <p
                      class="card-text"
                      v-if="s.description"
                      v-html="s.description"
                    ></p>
                    <h3 class="font-weight-bolder mt-10" v-if="s.criteria">
                      Criteria
                    </h3>
                    <p
                      class="card-text"
                      v-if="s.criteria"
                      v-html="s.criteria"
                    ></p>
                    <div class="row">
                      <div class="col-6 col-md-3" v-if="s.startDate">
                        <span class="d-block font-weight-bold mb-4"
                          >Start Date</span
                        >
                        <span
                          class="btn btn-light-primary btn-sm font-weight-bold btn-upper btn-text"
                          >{{ s.startDate | moment("D MMM  YYYY") }}</span
                        >
                      </div>
                      <div class="col-6 col-md-3" v-if="s.endDate">
                        <span class="d-block font-weight-bold mb-4"
                          >End Date</span
                        >
                        <span
                          class="btn btn-light-primary btn-sm font-weight-bold btn-upper btn-text"
                          >{{ s.endDate | moment("D MMM  YYYY") }}</span
                        >
                      </div>
                      <div class="col-6 col-md-3" v-if="s.estimatedTime">
                        <span class="d-block font-weight-bold mb-4"
                          >Estimated</span
                        >
                        <span
                          class="btn btn-light-success btn-sm font-weight-bold btn-upper btn-text"
                          >{{ s.estimatedTime }} h</span
                        >
                      </div>
                      <div
                        class="col-6 col-md-3"
                        v-for="po in s.points"
                        :key="po._id"
                      >
                        <span class="d-block font-weight-bold mb-4"
                          >Points</span
                        >
                        <span
                          class="btn btn-light-danger btn-sm font-weight-bold btn-upper btn-text"
                          >{{ po.points }} points</span
                        >
                      </div>
                      <div class="col-4 col-md-2" v-if="s.numberOfUsers">
                        <span class="d-block font-weight-bold mb-4"
                          >Tipology</span
                        >
                        <span
                          class="btn btn-sm font-weight-bold btn-upper btn-text"
                          v-if="s.numberOfUsers > 1"
                        >
                          <i class="fas fa-users"></i>
                        </span>
                        <span
                          class="btn btn-sm font-weight-bold btn-upper btn-text"
                          v-if="s.numberOfUsers < 2"
                        >
                          <i class="fas fa-user"></i>
                        </span>
                      </div>
                      <div
                        class="col-6 col-md-6 pt-0"
                        v-for="po in s.points"
                        :key="po._id"
                      >
                        <!-- !i.project.hasParent -->
                        <div
                          v-if="i.dateFinished && i.project._id == s._id"
                          class="row"
                        >
                          <div class="col-md-6">
                            <span class="d-block font-weight-bold mb-4"
                              >Stars</span
                            >
                            <div class="row ml-0 my-1">
                              <div>
                                <i v-if="i.stars >= 1" class="fas fa-star"></i>
                                <i v-else class="far fa-star"></i>
                              </div>
                              <div>
                                <i v-if="i.stars >= 2" class="fas fa-star"></i>
                                <i v-else class="far fa-star"></i>
                              </div>
                              <div>
                                <i v-if="i.stars >= 3" class="fas fa-star"></i>
                                <i v-else class="far fa-star"></i>
                              </div>
                              <div>
                                <i v-if="i.stars >= 4" class="fas fa-star"></i>
                                <i v-else class="far fa-star"></i>
                              </div>
                              <div>
                                <i v-if="i.stars >= 5" class="fas fa-star"></i>
                                <i v-else class="far fa-star"></i>
                              </div>
                            </div>
                          </div>
                          <div
                            class="col-6 col-md-6"
                            v-for="po in s.points"
                            :key="po._id"
                          >
                            <div>
                              <!-- v-if="s.dateFinished" -->
                              <span class="d-block font-weight-bold mb-4"
                                >Points achieved</span
                              >
                              <div class="row ml-0 my-1">
                                <div>
                                  <span
                                    v-if="i.stars == 1"
                                    class="btn btn-light-danger btn-sm font-weight-bold btn-upper btn-text"
                                    >{{ po.points * 0.1 }} points</span
                                  >
                                  <span
                                    v-else-if="i.stars == 2"
                                    class="btn btn-light-warning btn-sm font-weight-bold btn-upper btn-text"
                                    >{{ po.points * 0.3 }} points</span
                                  >
                                  <span
                                    v-else-if="i.stars == 3"
                                    class="btn btn-light-warning btn-sm font-weight-bold btn-upper btn-text"
                                    >{{ po.points * 0.5 }} points</span
                                  >
                                  <span
                                    v-else-if="i.stars == 4"
                                    class="btn btn-light-success btn-sm font-weight-bold btn-upper btn-text"
                                    >{{ po.points * 0.7 }} points</span
                                  >
                                  <span
                                    v-else-if="i.stars == 5"
                                    class="btn btn-light-success btn-sm font-weight-bold btn-upper btn-text"
                                    >{{ po.points }} points</span
                                  >
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>

                    <div class="card-footer">
                      <h4 class="text-dark">Comments</h4>
                      <div v-if="i.comments.length > 0" class="mt-10">
                        <div
                          class="alert alert-success mb-3"
                          v-for="c in i.comments"
                          :key="c._id"
                        >
                          <p>
                            <span>{{ c.date | moment("DD-MM-YYYY") }}</span>
                            {{ c.text }}
                          </p>
                        </div>
                      </div>
                      <div v-else>
                        <p>You don't have any comments</p>
                      </div>
                      <!--                  <b-form-textarea-->
                      <!--                      class="mt-10"-->
                      <!--                      v-model="comment"-->
                      <!--                      id="comment-text"-->
                      <!--                      placeholder="Enter a comment"-->
                      <!--                      rows="3"-->
                      <!--                      max-rows="6"-->
                      <!--                  ></b-form-textarea>-->
                      <!--                  <b-button variant="primary" v-on:click="addComment(s)" class="mt-5"-->
                      <!--                  >Add comment</b-button>-->
                    </div>
                  </div>
                </div>
              </div>
            </b-collapse>
          </div>
        </div>
      </div>
      <div class="col-12 col-md-4 sidebar">
        <div class="card card-custom gutter-b mt-0">
          <div class="card-body pt-4">
            <div class="mb-0">
              <div class="d-flex align-items-center pt-7">
                <div class="symbol symbol-45 symbol-light mr-4">
                  <span class="symbol-label p-6">
                    <span class="text-dark">
                      <i class="fas fa-signal"></i>
                    </span>
                  </span>
                </div>
                <div class="d-flex flex-column flex-grow-1">
                  <span
                    class="text-dark-75 mb-1 font-size-lg font-weight-bolder"
                    >Level</span
                  >
                </div>
                <span
                  class="font-weight-bolder label label-xl label-light-success label-inline px-3 py-5 min-w-45px"
                  v-if="instance.project.level"
                >
                  {{ instance.project.level.lvl }}
                </span>
              </div>
              <div class="d-flex align-items-center pt-7">
                <div class="symbol symbol-45 symbol-light mr-4">
                  <span class="symbol-label p-6">
                    <span class="text-dark">
                      <i class="far fa-clock"></i>
                    </span>
                  </span>
                </div>
                <div class="d-flex flex-column flex-grow-1">
                  <span
                    class="text-dark-75 mb-1 font-size-lg font-weight-bolder"
                    >Time</span
                  >
                  <span class="text-muted font-weight-bold">Estimated</span>
                </div>
                <span
                  class="font-weight-bolder label label-xl label-light-success label-inline px-3 py-5 min-w-45px"
                  >{{ calculateTime(instance) }} h</span
                >
              </div>
              <div
                class="d-flex align-items-center pt-7"
                v-for="p in instance.project.points"
                :key="p._id"
              >
                <div class="symbol symbol-45 symbol-light mr-4">
                  <span class="symbol-label p-6">
                    <span
                      class="text-dark"
                      v-if="p.profile.name == 'Developer'"
                    >
                      <i class="fas fa-laptop-code"></i>
                    </span>
                    <span class="text-dark" v-if="p.profile.name == 'Designer'">
                      <i class="fas fa-drafting-compass"></i>
                    </span>
                  </span>
                </div>
                <div class="d-flex flex-column flex-grow-1">
                  <span
                    class="text-dark-75 mb-1 font-size-lg font-weight-bolder"
                    >{{ p.profile.name }}</span
                  >
                  <span class="text-muted font-weight-bold">Points</span>
                </div>
                <span
                  class="font-weight-bolder label label-xl label-light-success label-inline px-3 py-5 min-w-45px"
                  >{{ p.points }}</span
                >
              </div>
              <div v-if="instance.project.hasParent">
                <div
                  class="d-flex align-items-center pt-7"
                  v-for="p in project.points"
                  :key="p._id"
                >
                  <div class="symbol symbol-45 symbol-light mr-4">
                    <span class="symbol-label p-6">
                      <span
                        class="text-dark"
                        :style="
                          'background-color:' +
                            profiles.find(pro => pro._id == p.profile).color
                        "
                      >
                        <i
                          class="fas  port "
                          :class="
                            profiles.find(pro => pro._id == p.profile).image
                          "
                        ></i>
                      </span>
                    </span>
                  </div>
                  <div class="d-flex flex-column flex-grow-1">
                    <span
                      class="text-dark-75 mb-1 font-size-lg font-weight-bolder"
                      >{{
                        profiles.find(pro => pro._id == p.profile).name
                      }}</span
                    >
                    <span class="text-muted font-weight-bold">Points</span>
                  </div>
                  <span
                    class="font-weight-bolder label label-xl label-light-success label-inline px-3 py-5 min-w-45px"
                    >{{ p.points }}</span
                  >
                </div>
              </div>
              <div class="d-flex align-items-center pt-7" v-else>
                <div class="symbol symbol-45 symbol-light mr-4">
                  <span class="symbol-label p-6">
                    <i class="fas fa-award"></i>
                  </span>
                </div>
                <div class="d-flex flex-column flex-grow-1">
                  <span
                    class="text-dark-75 mb-1 font-size-lg font-weight-bolder"
                    >Total</span
                  >
                  <span class="text-muted font-weight-bold">Points</span>
                </div>
                <span
                  class="font-weight-bolder label label-xl label-light-success label-inline px-3 py-5 min-w-45px"
                  >{{ calculatePoints(instance) }}</span
                >
              </div>
            </div>
          </div>
        </div>

        <div class="verification mb-7">
          <span
            class="btn btn-warning col-12 font-weight-bold"
            v-on:click="ValidateInstance(instance._id, currentUser.user.userId)"
            v-if="
              !instance.dateFinished &&
                !instance.cancelled &&
                instance.verification.length < 1
            "
            >Complete</span
          >
        </div>
        <!--        <div class="comments">-->
        <!--          <div class="card card-custom">-->
        <!--            <div class="card-body">-->
        <!--              <h4 class="text-dark">Comments</h4>-->
        <!--              <div v-if="instance.comments.length>0" class="mt-10">-->
        <!--                <div-->
        <!--                  class="alert alert-success mb-3"-->
        <!--                  v-for="c in instance.comments"-->
        <!--                  :key="c._id"-->
        <!--                >-->
        <!--                      <p>-->
        <!--                        <span>{{c.date | moment("DD-MM-YYYY")}}</span> {{ c.text }}-->
        <!--                      </p>-->

        <!--                </div>-->
        <!--              </div>-->
        <!--              <div v-else>-->
        <!--                <p>You don't have any comments</p>-->
        <!--              </div>-->
        <!--              <b-form-textarea-->
        <!--                class="mt-10"-->
        <!--                v-model="comment"-->
        <!--                id="comment-text"-->
        <!--                placeholder="Enter a comment"-->
        <!--                rows="3"-->
        <!--                max-rows="6"-->
        <!--              ></b-form-textarea>-->
        <!--              <b-button variant="primary" v-on:click="addComment()" class="mt-5"-->
        <!--                >Add comment</b-button-->
        <!--              >-->
        <!--            </div>-->
        <!--          </div>-->
        <!--        </div>-->
        <!-- <div class="btn btn-block btn-primary font-weight-bolder py-4" v-on:click="createInstance()">Start project</div> -->
      </div>
    </div>
  </div>
</template>

<script>
import { SET_BREADCRUMB } from "@/core/services/store/breadcrumbs.module";
import axios from "axios";
import { mapGetters } from "vuex";
var id;

export default {
  name: "instance-single",
  components: {},
  data() {
    return {
      hover: false,
      insta: { verification: [] },
      instance: [],
      usuari: [],
      comment: "",
      project: [],
      instasection: { project: "", users: [] },
      instasectiongrup: { project: "", team: "", users: [] },
      team: [],
      numSeccionsAmbInstancia: 0,
      ultimaAcabada: 0,
      instancia: []
    };
  },

  created() {
    id = this.$route.params.projectId;
    axios
      .get(
        "instances/" +
          id +
          "?fields=project,project.level,project.tags,project.sections,project-level,project-points.profile,project-sections,users, instances"
      )
      .then(response => {
        this.instance = response.data;
        this.insta.verification = response.data.verification;
        console.log("instances filles", this.instance.instances);
        console.log("instance pare", this.instance);

        let instanciesUsuari = this.instance.instances.filter(i =>
          i.users.includes(this.currentUser.user.userId)
        );
        this.numSeccionsAmbInstancia = instanciesUsuari.length;
        this.ultimaAcabada = instanciesUsuari[instanciesUsuari.length - 1]
          .dateFinished
          ? true
          : false;
        console.log("instacies usurai", instanciesUsuari);
        console.log("ultima acabada?", this.ultimaAcabada);
      });
    axios
      .get(
        "users/" + this.currentUser.user.userId + "?fields=instances-project"
      )
      .then(response => {
        this.usuari = response.data;
        console.log("user", this.usuari);
      });
  },

  mounted() {
    this.$store.dispatch(SET_BREADCRUMB, [{ title: "Project" }]);
  },
  methods: {
    createInstance: function(project, numofusers, section, user) {
      console.log("project", project);
      console.log("numofusers", numofusers);
      console.log("project section", section);

      if (numofusers === 1) {
        this.instasection.project = section;
        this.instasection.users.push(user.userId);
        console.log("insta", this.instasection);
        axios.post("instances", this.instasection).then(response => {
          console.log("saved project", response);
          this.instance.instances.push(response.data._id);
          if (response.status == 201) {
            axios
              .put("instances/" + this.instance._id, this.instance)
              .then(responses => {
                console.log("saved project section", responses);
              });
          }
        });
        this.$router.push({ name: "projects" });
        this.insta = [];
      } else {
        axios.get("/teams").then(response => {
          this.team = response.data;
          console.log(this.team);
          this.instasectiongrup.project = section;
          this.instasectiongrup.team = user.team;

          for (let i = 0; i < this.team.length; i++) {
            if (this.team[i]._id === user.team) {
              for (let u = 0; u < this.team[i].users.length; u++) {
                this.instasectiongrup.users.push(this.team[i].users[u]);
              }
            }
          }
          console.log("insta", this.instasectiongrup);
          axios.post("instances", this.instasectiongrup).then(response => {
            console.log("saved project", response);
            this.instance.instances.push(response.data._id);
            if (response.status == 201) {
              axios
                .put("instances/" + this.instance._id, this.instance)
                .then(responses => {
                  console.log("saved project section", responses);
                });
            }
            this.$router.push({ name: "projects" });
          });
        });
      }
    },
    calculatePoints(inst) {
      let total = 0;
      for (let i = 0; i < inst.project.sections.length; i++) {
        total += inst.project.sections[i].points.reduce(
          (accum, s) => accum + s.points,
          0
        );
      }
      return total;
    },
    calculateTime(i) {
      if (i.project.estimatedTime) {
        return i.project.estimatedTime;
      } else {
        return i.project.sections.reduce(
          (accum, s) => accum + s.estimatedTime,
          0
        );
      }
    },
    ValidateInstance: function(project, user) {
      this.insta.verification.push(user);
      this.instance.verification.push(user);
      console.log("insta", this.insta);
      axios.put("instances/" + project, this.insta).then(response => {
        console.log("saved verifications", response);
        if (response.status == 200) {
          console.log("creada");
        }
      });
      this.insta = [];
    },
    addComment: function() {
      console.log("click", this.comment);
      if (this.instance.comments) {
        this.instance.comments.push(this.comment);
      } else {
        this.instance.comments = [];
        this.instance.comments.push(this.comment);
      }
      console.log(this.instance);
      axios
        .put("instances/" + this.instance._id, this.instance)
        .then(response => {
          console.log(response);
        });
    }
  },
  computed: {
    profiles() {
      return this.$store.getters.getProfiles;
    },
    ...mapGetters(["currentUser", "breadcrumbs", "pageTitle", "layoutConfig"])
  }
};
</script>
<style>
.tag-dev {
  background-color: #fff4df;
}
.tag-dis {
  background-color: #e1f0ff;
}
.info-singel-project {
  border-radius: 6px;
  padding: 11px;
}
i {
  color: #6cc5a5;
}

img {
  margin-right: 10px;
}

.symbol.symbol-light-info .symbol-label.bg-js {
  background-color: rgba(246, 78, 96, 0.5);
}
.symbol.symbol-45 .symbol-label {
  width: 20px;
  height: 20px;
}
.item-grafica-projecte {
  margin-bottom: 20px;
}
.apexcharts-legend {
  display: none !important;
}
p ul {
  padding-left: 30px;
}
p img {
  margin: 10px 0;
}
</style>
